// Convert height from feet'inches' format to inches
function convertHeightToInches(height: string): number {
  // If height is already in inches (just a number)
  if (/^\d+$/.test(height)) {
    return parseInt(height, 10);
  }

  // Parse feet'inches' format
  const match = height.match(/^(\d+)'(\d+)'?$/);
  if (match) {
    const feet = parseInt(match[1]!, 10);
    const inches = parseInt(match[2]!, 10);
    return (feet * 12) + inches;
  }

  // If format is not recognized, return 0
  return 0;
}

export const BmiCalculate = (weight: number, height: string) => {
  if (weight && height) {
    const heightInInches = convertHeightToInches(height);
    if (heightInInches === 0) return undefined;

    // Convert inches to meters (1 inch = 0.0254 meters)
    const heightInMeters = heightInInches * 0.0254;
    
    // Convert pounds to kg (1 lb = 0.453592 kg)
    const weightInKg = weight * 0.453592;
    
    const bmiValue = weightInKg / (heightInMeters * heightInMeters);
    return parseFloat(bmiValue.toFixed(1));
  }
  return undefined;
}